import React from 'react';
import { useNavigate } from 'react-router-dom';
import MarketListWizard from '../components/MarketListWizard';

const MarketList = () => {
    const navigate = useNavigate();

    const handleClose = () => {
        // Navigate back to where the user came from, or dashboard as fallback
        if (window.history.length > 2) {
            navigate(-1);
        } else {
            navigate('/dashboard');
        }
    };

    return (
        <MarketListWizard
            isOpen={true}
            onClose={handleClose}
        />
    );
};

export default MarketList;
